import React from 'react';

const OrderDetails = () => {
    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <h5>Sipariş Detayları</h5>
                    {/* Add your order details content here */}
                </div>
            </div>
        </div>
    );
};

export default OrderDetails; 